'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  gameWidth: 1024,
  gameHeight: 576,
  localStorageName: 'phaseres6webpack'
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 373
// module chunks = 0